export function getTimeStamp () {
    return new Date().toISOString().replace("Z", "");
}